// extracted by mini-css-extract-plugin
export default {"info":"info_info__qgcHn","infoContent":"info_infoContent__2c70S","infoMain":"info_infoMain__fRPk9","delivery":"info_delivery__ZRynd","security":"info_security__KwF1y"};